<div class="tab-content">
    <div class="tab-pane active m-scrollable" id="m_quick_sidebar_tabs_messenger" role="tabpanel">
      <div  class="m-content">
        @if(_candidate?._id){
          <div class="container-fixed">
            <div class="m-portlet__body m-portlet__body--no-padding">
              <a [routerLink]="['/', userIndex, 'recruiter', _candidate?._id]" class="btn btn-outline-secondary back-btn mb-3"
                ><i class="fas fa-arrow-left"></i>&nbsp;<span>Back</span>
              </a>
              <div class="flex justify-end mb-4">
                <button
                  class="py-0.5 px-2 font-medium f-16"
                  style="border-radius: 6px; border: 1px solid var(--border-subtle)"
                  (click)="devView = !devView"
                  [ngClass]="{
                    'bg-blue-50 text-blue-800': devView,
                    'bg-white text-black': !devView
                  }"
                >
                  <i class="fa-solid fa-code" style="font-size: 12px"></i>
                </button>
              </div>
              <app-history-logs
                [resourceType]="'candidates'" [devView]="devView" [resourceId]="$safeNavigationMigration(_candidate?._id)"
              ></app-history-logs>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  